// extracted by mini-css-extract-plugin
module.exports = {"postWrapper":"postWrapper-module--postWrapper--wHJmq","post":"postWrapper-module--post--1VXoK","postWrapperForm":"postWrapper-module--postWrapperForm--1YV66"};